import React from "react"

import { useTranslation, useLanguageQuery } from "next-export-i18n"

const Header = () => {
  const { t } = useTranslation()
  const [query] = useLanguageQuery()

  return (
    <div className="w-full bg-white relative ">
      <div className="flex  max-w-7xl  mx-auto pb-10 md:pb-14 px-4 md:px-4 mt-28 md:mt-6 xl:mt-0">
        <div className="self-auto md:self-center">
          <h2 className="text-secondary text-xl md:text-2xl xl:text-4xl md:pt-14 text-center md:text-left font-semibold pb-2 md:pb-8   ">
            Privacy Policy
          </h2>
          <div className="grid  grid-cols-1 md:grid-cols-2 gap-4 md:gap-12 relative">
            <div className="">
              <div>
                <h2 className="text-woundTextDark text-xl md:text-2xl xl:text-2xl pb-3  text-center md:text-left font-semibold   ">
                  Protecting your privacy
                </h2>
                <p className=" text-base xl:text-xl pb-4 md:mr-12 text-center md:text-left font-normal  ">
                  Carea Community Health Centre (Carea) is committed to
                  protecting your personal health information. We protect your
                  personal health information in accordance with the Ontario
                  Personal Health Information Protection Act, 2004 (PHIPA) and
                  all other applicable laws.
                </p>
                <p className="text-base xl:text-xl pb-4 md:mr-12 text-center md:text-left font-normal  ">
                  Carea collects and uses the minimum amount of personal health
                  information required to provide and/or facilitate your health
                  care and services and takes steps to protect your personal
                  health information from theft or loss, and to prevent
                  unauthorized access, copying modification, use, disclosure,
                  and disposal.
                </p>
              </div>
            </div>
            <div className="">
              <div>
                <h2 className="text-woundTextDark text-xl md:text-2xl xl:text-2xl pb-3  text-center md:text-left font-semibold   ">
                  Collection of personal health information
                </h2>
                <p className=" text-base xl:text-xl pb-4 md:mr-12 text-center md:text-left font-normal  ">
                  We collect personal health information about you directly from
                  you or from the person acting on your behalf so that we can
                  provide you with health care and services. The personal health
                  information that we collect may include, for example, your
                  name, date of birth, address, health history, records of your
                  visits to Carea, and the treatments and services that you
                  receive during those visits.
                </p>
                <p className=" text-base xl:text-xl pb-4 md:mr-12 text-center md:text-left font-normal  ">
                  Occasionally, we may collect personal health information about
                  you from other sources, such as diagnostic imaging facilities,
                  laboratories, or other agencies involved in your care and
                  services, if we have obtained your consent, or if the law
                  permits.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Header
